import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Trash2, Send } from "lucide-react";

export default function AdminCampaigns() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", subject: "", body: "", segment: "newsletter" });

  const load = async () => { const { data } = await api.get("/admin/campaigns"); setItems(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/admin/campaigns", form);
      toast.success("Campaña creada");
      setForm({ name: "", subject: "", body: "", segment: "newsletter" });
      load();
    } catch { toast.error("Error"); }
  };
  const send = async (id) => {
    const { data } = await api.post(`/admin/campaigns/${id}/send`);
    toast.success(`${data.recipients_count} destinatarios (mock)`);
    load();
  };
  const remove = async (id) => { await api.delete(`/admin/campaigns/${id}`); load(); };

  return (
    <div data-testid="admin-campaigns-page">
      <h1 className="font-serif text-5xl tracking-tighter">Campañas de marketing</h1>
      <p className="text-[#5B605E] mt-1">Crea campañas de email para tu audiencia. <strong>(envío MOCKED — sin email real)</strong></p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
        <div className="bg-white border border-[#E8E3DA] p-6">
          <h2 className="font-serif text-2xl mb-4">Nueva campaña</h2>
          <div className="space-y-3">
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Nombre interno" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Asunto" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
            <textarea rows={6} className="w-full border border-[#2C302E] bg-transparent px-3 py-2" placeholder="Contenido..." value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
            <select className="w-full border border-[#2C302E] bg-transparent px-3 py-2" value={form.segment} onChange={(e) => setForm({ ...form, segment: e.target.value })}>
              <option value="newsletter">Newsletter</option>
              <option value="customers">Clientes</option>
              <option value="all">Todos</option>
            </select>
            <button onClick={create} className="btn-primary w-full">Crear</button>
          </div>
        </div>

        <div className="lg:col-span-2 space-y-3">
          {items.map((c) => (
            <div key={c.id} className="bg-white border border-[#E8E3DA] p-4">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-serif text-xl">{c.name}</p>
                  <p className="text-sm text-[#5B605E]">{c.subject}</p>
                  <p className="text-xs uppercase mt-1">{c.segment} · {c.status}</p>
                </div>
                <div className="flex gap-2">
                  {c.status !== "sent" && <button onClick={() => send(c.id)} className="btn-ghost"><Send size={14}/> Enviar</button>}
                  <button onClick={() => remove(c.id)} className="hover:text-[#9E2A2B] p-2"><Trash2 size={14}/></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
